import { track } from '@doordash/lib-tracking'
import { get } from 'lodash'
import i18n from '../i18n/'
import { getIsMobile } from '../utilities/userAgent'
import { clientData, cookieData } from './commonData'

declare const window

/**
 * A function that wraps our Redux instrumentation tracking to append common
 * event payload data to all tracking events.
 *
 * @param {string} name The name for the event.
 * @param {Function} f A function that generates the event payload data.
 * @param {Window} Window The window object. Defaults to window but can
 *   be overridden for testing.
 */
export const trackWithInfo = (name, f = (...args) => ({}), Window = window) => {
  const clientProps = {
    hasTouchEvents: Window.ontouchstart !== undefined,
    isMobile: getIsMobile(Window),
    innerWidth: Window.innerWidth,
    innerHeight: Window.innerHeight,
    location: Window.location,
    document: Window.document,
    navigator: Window.navigator,
    version: get(Window, '__dd.version'),
    currentLanguage: i18n.getCurrentLanguage(),
  }
  const cookie = Window.document.cookie || ''

  return track(name, state => ({
    ...f(state),
    _clientData: {
      ...clientData(clientProps),
    },
    _cookieData: {
      ...cookieData(cookie),
    },
  }))
}
